import { render, staticRenderFns } from "./ReservationExperiencesPhone.vue?vue&type=template&id=5050a951&scoped=true&"
import script from "./ReservationExperiencesPhone.vue?vue&type=script&lang=js&"
export * from "./ReservationExperiencesPhone.vue?vue&type=script&lang=js&"
import style0 from "./ReservationExperiencesPhone.vue?vue&type=style&index=0&id=5050a951&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050a951",
  null
  
)

export default component.exports